// Preline ApexCharts Helper Function
// Global theme observer - shared across all charts
let globalThemeObserver = null;
let chartInstances = new Map();

function initGlobalThemeObserver() {
  if (globalThemeObserver) return;
  
  let isDark = document.documentElement.classList.contains("dark");
  
  globalThemeObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        let newIsDark = document.documentElement.classList.contains("dark");
        if (newIsDark !== isDark) {
          isDark = newIsDark;
          const mode = isDark ? "dark" : "light";
          // Update all chart instances
          chartInstances.forEach((data, chart) => {
            chart.updateOptions(data.config(mode));
          });
        }
      }
    });
  });
  globalThemeObserver.observe(document.documentElement, { attributes: true });
}

window.buildChart = function (selector, config) {
  let element = document.querySelector(selector);
  if (!element) return;

  let isDark = document.documentElement.classList.contains("dark");
  let chart = new ApexCharts(element, config(isDark ? "dark" : "light"));
  chart.render();

  // Store chart instance and config for theme updates
  chartInstances.set(chart, { config, element });
  
  // Initialize global observer if not already done
  initGlobalThemeObserver();

  // Cleanup on element removal
  if (typeof MutationObserver !== 'undefined') {
    const cleanupObserver = new MutationObserver(function() {
      if (!document.contains(element)) {
        chart.destroy();
        chartInstances.delete(chart);
        cleanupObserver.disconnect();
      }
    });
    cleanupObserver.observe(element.parentNode || document.body, {
      childList: true,
      subtree: true
    });
  }

  return chart;
};
